import React from 'react';
import { eq } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery, useMutation } from '@apollo/client';
import { SystemSettings } from '.';
import SiteSettings from './siteSettings';
import ContentSettings from './contentSettings';
import { CLIENT_STATE, SET_CLIENT_STATE } from '../../../graphqls';

export default function GeneralSettings() {
  const {
    loading,
    data: {
      generalSettingsCurrentTab,
      sideMenu,
    } = {},
  } = useQuery(CLIENT_STATE);
  const [setState] = useMutation(SET_CLIENT_STATE);
  const onSwitch = ({ currentTarget: { dataset: { menu } } }) => {
    setState({ variables: { generalSettingsCurrentTab: menu } });
  };
  const onClose = () => setState({ variables: { sideMenu: '' } });
  let shownSetting = '';

  switch (generalSettingsCurrentTab) {
    case 'content':
      shownSetting = (<ContentSettings />);
      break;
    case 'system':
      shownSetting = (<SystemSettings />);
      break;
    case 'theme':
      shownSetting = (<SiteSettings />);
      break;
    default:
      break;
  }

  if (loading || !eq(sideMenu, 'generalSettingsView')) {
    return '';
  }

  return (
    <div className="main-settings-container">
      <div className="main-settings-view">
        <div className="main-settings-spacer" />
        <div className="main-settings-view-inner">
          <button
            type="button"
            className="hollow-btn close-main-settings"
            onClick={onClose}
          >
            <FontAwesomeIcon icon={['fal', 'times']} />
          </button>
          <ul className="main-settings-tab">
            <li className={eq(generalSettingsCurrentTab, 'theme') ? 'active' : ''}>
              <button
                type="button"
                className="hollow-btn"
                data-menu="theme"
                onClick={onSwitch}
              >
                <FontAwesomeIcon icon={['fal', 'paint-roller']} />
              </button>
            </li>
            <li className={eq(generalSettingsCurrentTab, 'content') ? 'active' : ''}>
              <button
                type="button"
                className="hollow-btn"
                data-menu="content"
                onClick={onSwitch}
              >
                <FontAwesomeIcon icon={['fal', 'list-ul']} />
              </button>
            </li>
            <li className={eq(generalSettingsCurrentTab, 'system') ? 'active' : ''}>
              <button
                type="button"
                className="hollow-btn"
                data-menu="system"
                onClick={onSwitch}
              >
                <FontAwesomeIcon icon={['fal', 'sliders-v']} />
              </button>
            </li>
          </ul>
          {shownSetting}
        </div>
      </div>
    </div>
  );
}
